
import { Component, Vue, Watch, Prop } from "vue-property-decorator";
@Component
export default class SingleReportHeader extends Vue {
  @Prop({ default: true }) readonly excelShow!: boolean;
  @Prop({ default: () => {} }) readonly dataFrom!: any;
  @Prop({ default: false }) readonly isRange!: boolean;
  @Prop({ default: false }) readonly loading!: boolean;
  @Prop({ default: () => null }) readonly toPdf!: Function;
  @Prop({ default: () => null }) readonly toExe!: Function;
  select = {
    platform_list: [],
    app_list: [],
  };
  expConfig = {
    show: false,
  };
  getAppList() {
    return (this as any).app_list.filter(
      (el: any) => el.platform == this.dataFrom.platid
    );
  }
  updateSelect(val) {
    let item: any = (this as any).app_list.find(
      (el: any) => el.platform == val
    );
    this.dataFrom.app_id = item ? item.appid : 0;
  }
  handleClick() {
    this.$emit("search");
  }
  initFunc() {
    this.dataFrom.platid = (this as any).getinitPlatId();
    let first: any = (this as any).app_list.find(
      (el: any) => el.platform == this.dataFrom.platid
    );
    this.dataFrom.app_id = first.appid;
    this.$emit("search");
  }
  toOut(val) {
    this.$emit("to-ep", val);
    this.expConfig.show = false;
  }
  created() {
    this.initFunc();
  }
  mounted() {}
}
